export default __webpack_public_path__ + "static/media/CV.bf7c25e5.svg";